/**
 * @generated SignedSource<<a717877fbd131d399c695beef303f65f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConsolidatedNewPlayers_Round$data = {
  readonly booking: {
    readonly __typename: string;
    readonly startSlot: {
      readonly agenda: {
        readonly facility: {
          readonly copyOverrides: {
            readonly bookingPlayer: {
              readonly plural: string;
            } | null | undefined;
            readonly lessonPlayer: {
              readonly plural: string;
            } | null | undefined;
          };
        };
      };
    } | null | undefined;
  };
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"useGetLineItemsAndPriceForRound_Round">;
  readonly " $fragmentType": "ConsolidatedNewPlayers_Round";
};
export type ConsolidatedNewPlayers_Round$key = {
  readonly " $data"?: ConsolidatedNewPlayers_Round$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConsolidatedNewPlayers_Round">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plural",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConsolidatedNewPlayers_Round",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "booking",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "startSlot",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Agenda",
              "kind": "LinkedField",
              "name": "agenda",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Facility",
                  "kind": "LinkedField",
                  "name": "facility",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FacilityCopyOverrides",
                      "kind": "LinkedField",
                      "name": "copyOverrides",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "NounOverride",
                          "kind": "LinkedField",
                          "name": "lessonPlayer",
                          "plural": false,
                          "selections": (v0/*: any*/),
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "NounOverride",
                          "kind": "LinkedField",
                          "name": "bookingPlayer",
                          "plural": false,
                          "selections": (v0/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetLineItemsAndPriceForRound_Round"
    }
  ],
  "type": "Round",
  "abstractKey": "__isRound"
};
})();

(node as any).hash = "27d9a6212894309d24af583c330a2043";

export default node;
